// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__4nNBF","left":"StickyBox_left__F5sQi","right":"StickyBox_right__3tA_I"};